import React from 'react';
import styles from './HomePageSectionHeader.module.scss';
import Icon from '../../../../components/Icon/Icon';
import cx from 'classnames';

const HomePageSectionHeader = ({ icon = null, title, description, className }) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      {icon && <Icon className={styles.icon} src={icon} />}
      <div className={cx(styles.container, { [styles.noIcon]: !icon })}>
        <h3 tabIndex={0} className={styles.title}>{title}</h3>
        <span tabIndex={0} className={styles.description}>{description}</span>
      </div>
    </div>
  );
};

export default HomePageSectionHeader;
